import React, { useState } from 'react';
import { Box } from '@common-fe/common-fe';

import useGetAddressUndeliverableQuery from '../queries/useGetAddressUndeliverable.query';

import BadAddressBanner from './BadAddressBanner';
import ReviewAddressModal from './ReviewAddressModal';

const BadAddressBannerContainer: React.FC = () => {
  const { isUndeliverable } = useGetAddressUndeliverableQuery();
  const [isReviewModalOpen, setIsReviewModalOpen] = useState(false);

  return (
    <>
      {isUndeliverable && (
        <Box margin={{ vertical: 'spacing16' }}>
          <BadAddressBanner onReviewClick={() => setIsReviewModalOpen(true)} />
        </Box>
      )}
      <ReviewAddressModal
        isOpen={isReviewModalOpen}
        onClose={() => setIsReviewModalOpen(false)}
      />
    </>
  );
};

export default BadAddressBannerContainer;
